import { Component, OnInit, Input, ViewChild, Output, EventEmitter  } from '@angular/core';
import { PageSearchableListConfig, PageHeaderBarConfig, PageSubheaderBarConfig } from './page-config-api';
import { FieldDefinition } from '../../fw/dynamic-forms/field-definition';
import { DynamicGridComponent } from '../../fw/dynamic-grids/dynamic-grid.component';

@Component({
    selector: 'fw-page-searchable-list',
    template: require('./page-searchable-list.component.html'),
    styles: [require('./page-searchable-list.component.css')]
})
export class PageSearchableListComponent implements OnInit {
    @Input() config = new PageSearchableListConfig();
    @ViewChild(DynamicGridComponent, {static: false}) grid: DynamicGridComponent;
    @Output() btnHeaderBarClick = new EventEmitter<any>();
    @Output() btnSubHeaderBarClick = new EventEmitter<any>();

    private pageHeaderBarConfig: PageHeaderBarConfig; 

    errorMessage: string;
    operation: string;

    constructor() { }

    ngOnInit() {
        this.pageHeaderBarConfig = {
            title: 'ZOEKOPTIES',
            buttonDefinition: [

            ]
        }
    }

    btnHeaderBarClicked(event) {
        this.btnHeaderBarClick.emit(event);
    }

    btnSubHeaderBarClicked(event) {
        this.btnHeaderBarClick.emit(event);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/pages/page-searchable-list.component.ts